import React from 'react';
import useBrowseProducts from '../hooks/useBrowseProducts';
import {useSelector} from 'react-redux';
import {selectProducts} from '../../../selectors';
import {getMessage} from '../../../components/common/Message';
import {BrowseList, BrowseSortBy, BrowseKeywords, BrowsePagination, Toolbar} from '../components';
import styled from 'styled-components';

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const CODES = {
    title: 'epic.affiliate.earnings.other_games.v2'
};

export interface BrowseSectionProps {
    messages: Record<string, string>;
    enableLink?: boolean;
}

const BrowseSection: React.FC<BrowseSectionProps> = ({messages, enableLink}) => {
    const productsState = useSelector(selectProducts);
    const browse = useBrowseProducts(productsState);
    const {lastFetch, loading, paging, queryState} = productsState || {};
    const isRendering = !lastFetch;
    const isProductsLoading = loading || browse.loading;

    return (
        <div>
            <Toolbar isRendering={isRendering} title={getMessage(messages, CODES.title)}>
                <BrowseSortBy
                    sortBy={queryState.sortBy}
                    sortDir={queryState.sortDir}
                    onChange={browse.onSortChange}
                />
                <BrowseKeywords keywords={queryState.keywords} onChange={browse.onKeywordsChange} />
            </Toolbar>

            <Content>
                <BrowseList
                    isRendering={isRendering || isProductsLoading}
                    products={browse.products}
                    enableLink={enableLink}
                    postsPerPage={queryState.count}
                />

                <BrowsePagination
                    isRendering={isRendering}
                    page={queryState.page}
                    totalPosts={paging.total}
                    postsPerPage={queryState.count}
                    onPageChange={browse.onPageChange}
                    onPostsPerPageChange={browse.onPostsPerPageChange}
                />
            </Content>
        </div>
    );
};

export default BrowseSection;
